// normalize CSS across browsers
import "./src/normalize.css";
// custom CSS styles
import "./src/style.css";

// Highlighting for code blocks
import "prismjs/themes/prism.css";

// Supports weights 200-900
import "@fontsource-variable/crimson-pro";
// Supports weights 200-700
import "@fontsource-variable/oswald";

import "@fontsource/cousine/400-italic.css";
import "@fontsource/cousine/700-italic.css";
import "@fontsource/cousine/400.css";
import "@fontsource/cousine/700.css";

// Click a figure in a post to view it full screen; click again (or Esc) to leave.
const onFigureClick = (e) => {
  const img = e.target.closest(".blog-post section img");
  if (!img) return;
  e.preventDefault();
  if (document.fullscreenElement) {
    document.exitFullscreen();
  } else if (img.requestFullscreen) {
    img.requestFullscreen();
  } else {
    window.open(img.currentSrc || img.src, "_blank");
  }
};

export const onClientEntry = () => {
  document.addEventListener("click", onFigureClick);
};
